import React, { useState, useEffect, useRef } from 'react';
import './Demat.css';
import Button from '../../Components/Button/Button';
import { FeatureCard } from '../../Components/Card/FeatureCard';
import DematAdvantages from '../../Data/DematAdvantages';
import SectionIds from '../../Helper/SectionId';
import goToLink from '../../Helper/GoToLink';
import GoToLinks from '../../Data/GoToLinks';
import { useInView } from 'framer-motion';
import SectionWithAnalytics from '../../Components/sectionWithAnalytics';

export default function Demat() {
  const [activeCard, setActiveCard] = useState(0);
  const [pauseTimer, setPauseTimer] = useState(false);

  const sectionRef = useRef(null);
  const inView = useInView(sectionRef);
  const onClickButtonHandle = () => goToLink(GoToLinks.accountOpening);

  const startTimer = () => {
    setPauseTimer(false);
  };

  const stopTimer = () => {
    setPauseTimer(true);
  };

  useEffect(() => {
    if (inView) {
      setActiveCard(0);
      startTimer();
    } else {
      stopTimer();
    }
  }, [inView]);



  useEffect(() => {

    const timer = setInterval(() => {
      if (!pauseTimer) {
        setActiveCard(prevActiveCard => {
          if (prevActiveCard === DematAdvantages.length - 1) {
            return 0;
          } else {
            return prevActiveCard + 1;
          }
        });
      }
    }, 2000);

    return () => clearInterval(timer);
  }, [pauseTimer]);

  return (
    <SectionWithAnalytics className='section section-demat' id={SectionIds.sectionDemat} ref={sectionRef}>
      <div className='top-section'>
        <div className='container-vertical res-gap-32'>
          <div className='container-vertical res-gap-16'>
            <h2 className='align-right'>Open 100% free <br /> <mark>Demat Account</mark></h2>
            <span className='subtitle fs-large align-right'>Get a lifetime free Demat & Trading Account</span>
          </div>
          <Button name="Get Started" className='align-right' onClick={onClickButtonHandle} />
        </div>
      </div>

      <div className="bottom-section container-vertical res-gap-16">
        <span className='fs-medium fw-semibold clr-primary-heading align-left'>Why open Demat Account with us</span>

        <div className="container-vertical res-gap-16"></div>

        {
          DematAdvantages.map((element, index) => (
            <FeatureCard
              key={index}
              icon={element.icon()}
              title={element.title}
              className={index === activeCard ? 'active' : ''}
              content={element.content}
              onMouseOver={() => {
                setPauseTimer(true);
                setActiveCard(index);
              }}
              onMouseLeave={() => {
                setPauseTimer(false);
              }}
            />
          ))
        }
      </div>
    </SectionWithAnalytics>
  );
}
